import DataTile from "../metrics/DataTile";
import React, {useState} from "react";
import {useSelector} from "react-redux";
import {BBDisableChildren, bbFindEntityWithinPortfolioOrSelf, isCurrentUserMemberOf,} from "../../../util/bbHelpers";
import CustomActiveShapePieChart from "../charts/CustomActiveShapePieChart";


const TileBRSocialAllTimeOpen = ({brSubscriptionRequired="Premium",overrideEnabledForAdminsStaff = false,}) => {

    // const {customerId} = props;

    /**************************/
    /*Setup State and Dispatch*/
    /**************************/
    const {customers, customerInView} = useSelector(({customer}) => customer);

    const {portfolios, entityInView, loadingCycleSocial} = useSelector(({breachrisk}) => breachrisk);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;

    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);
    const {authUser} = useSelector(({auth})=>auth);
    const isAdminStaff = isCurrentUserMemberOf(authUser, "admin") || isCurrentUserMemberOf(authUser, "staff");

    const isCorrectSubscriptionLevel = myEntity ? myEntity.active_subscription && myEntity.premium_subscription : null;

    // const enableData = brSubscriptionRequired ? (overrideEnabledForAdminsStaff && isAdminStaff) ? true : isCorrectSubscriptionLevel : true
    // console.log("looking at disabling ", brSubscriptionRequired, isAdminStaff, isCorrectSubscriptionLevel, "myEntity.active_sub etc", myEntity.active_subscription, myEntity.premium_subscription)


    const lastCycleId = myEntity && myEntity.settings && myEntity.settings.last_cycle_id;

    const social = myEntity
        && myEntity.cycles
        && lastCycleId
        && myEntity.cycles[lastCycleId]
        // && !loadingCycleSocial[lastCycleId]
        && myEntity.cycles[lastCycleId].social;

    const allTimeTotals = lastCycleId
        // && !loadingCycleSocial[lastCycleId]
        && social
        && social.allTimeTotals;


    const hasSocialTestData = lastCycleId
        // && !loadingCycleSocial[lastCycleId]
        && social
        && allTimeTotals
        && allTimeTotals.tests !== 0;


    // console.log("TileBRSocialAllTimeOpen", lastCycleId, myEntity, social, allTimeTotals)



    const showPieWith = (stateData) => {
        if (stateData && stateData[customerIdToUse] && myEntity
            // && !loadingCycleSocial[lastCycleId]
        ) {

            const numTestsSent = lastCycleId
            && social
            && social.allTimeTotals
                ? social.allTimeTotals.tests
                : null;


            const numTestsOpened = lastCycleId
            && social
            && social.allTimeTotals
                ? social.allTimeTotals.opens
                : null;

            console.log("TileBRSocialAllTimeOpen part 2", numTestsSent, numTestsOpened)

            try {

                const arrayData = numTestsSent!== 0
                    ?[{name: "Opened", value: numTestsOpened}, {name: "Not Opened", value: numTestsSent - numTestsOpened}]
                    : []

                return <div
                    className={"animated fadeIn animation-duration-7"}
                    style={{ marginTop: -40, marginBottom: -15 }}
                ><CustomActiveShapePieChart
                    data = {arrayData}
                    loading = {!arrayData}
                /></div>


            } catch(e) {
                console.warn(e);
                return null
            }
        } else {
            return null
        }
    }

    const valueFunction = (stateData) => {
        return lastCycleId
        && social
        && social.allTimeTotals
            ? social.allTimeTotals.opens
            : null;
    }

    return (
        <DataTile
            subTitle="Total Emails Opened"
            tipText={`Number of Spearphishing Emails opened since Social Engineering began. Opened means that we detected the spearphishing email was opened by the recipient. Note: Some security controls may prevent us from detecting this activity, so the actual number of opens may be higher.`}
            icon={<div
                className={"animated fadeIn animation-duration-7"}
                style={{ marginTop: -40, marginBottom: -15 }}
            ><CustomActiveShapePieChart
                data = {[]}
                // riskBy5={-1}
                loading
            /></div>}
            iconFunction = {showPieWith}
            iconClasses={" "}
            stateName="breachrisk"
            stateElement="portfolios"
            dontFetch
            // forceLoadingState = {myEntity && myEntity.settings && myEntity.settings.last_cycle_id && !loadingCycleSocial[lastCycleId] ? false : true}
            valueFunction={valueFunction}
        />
    )

}

export default TileBRSocialAllTimeOpen;